export default function SectionLabel({ children, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-2 font-body text-[11px] tracking-[0.28em] uppercase ${className}`}
      style={{ color: "#7CC4D8" }}
      data-testid="section-label"
    >
      <span className="inline-block w-6 h-px" style={{ background: "rgba(124,196,216,0.4)" }} />
      {children}
    </span>
  );
}
